import gsap from "gsap";
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";
import { quiz_Questions } from "./question";

export default class Quiz {
  constructor() {
    document
      .querySelector("#quizstartBtn")
      .addEventListener("click", this.onStart.bind(this));
    document
      .querySelector("#quizTryAgainBtn")
      .addEventListener("click", this.retryQuiz.bind(this));
    document
      .querySelector("#quizShareBtn")
      .addEventListener("click", this.shareThumbnail.bind(this));
    document
      .querySelector("#closeDetailBtn")
      .addEventListener("click", this.closeDetailsPopUp.bind(this));

    this.factBtn = document.getElementById("factBtn");
    this.fakeBtn = document.getElementById("fakeBtn");

    this.factBtn.addEventListener("click", () => this.checkAnswer("FACT"));
    this.fakeBtn.addEventListener("click", () => this.checkAnswer("FAKE"));
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));

    this.startButtonflag = false;
    this.optionButtonFlag = false;
    this.timeUp = false;
    this.timeStartOnce = true;
    this.time = 60;
    this.quizGameTry = 0;
    this.total_time_Taken = 0;

    // this.question_01;
    // this.question_02;
    // this.question_03;
    // this.question_04;
    // this.question_05;

    // this.question_01_answer;
    // this.question_02_answer;
    // this.question_03_answer;
    // this.question_04_answer;
    // this.question_05_answer;

    this.qImg = document.getElementById("qImg");
    this.qVideo = document.getElementById("qVideo");
    this.qText = document.getElementById("qText");

    this.counterText = document.getElementById("questionCount");

    this.ansImg = document.getElementById("ansImg");
    this.ansVideo = document.getElementById("ansVideo");
    this.ansIFrame = document.getElementById("ansIFrame");
    this.detailsText = document.getElementById("detailsText");

    this.loader = document.getElementById("iframeLoader");
    this.detailsImage = document.getElementById("detailsImage");
  }

  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
      case "send_Time":
        // console.log(data['message']['data']['timeTaken_360'])
        // console.log(data)
        this.timeTaken_360 = data["message"]["data"]["timeTaken_360"];
        // console.log(this.timeTaken_360)
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "QuizHome") return false;

    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_volume",
        data: {},
      },
    });

    document.querySelector(".quizBg").style.display = "block";

    document.querySelector("#quizhomeScr").style.display = "block";

    this.quizTitleIndex = 0;
    this.quiztitleContainer = document.querySelector(
      "#quizhomeScr .contents .quiztitle",
    );
    this.quizTitleInt = setInterval(() => {
      this.quizTitleIndex += 100 / 34;

      if (this.quizTitleIndex >= 99) {
        clearInterval(this.quizTitleInt);
        this.startButtonflag = true;
        document
          .querySelector("#quizhomeScr .contents .logo")
          .classList.add(`active`);
        document
          .querySelector("#quizhomeScr .contents .desc")
          .classList.add(`active`);
        document.querySelector("#quizstartBtn").classList.add(`active`);
      }

      this.quiztitleContainer.style.backgroundPosition = `0% ${this.quizTitleIndex}%`;
    }, 45);
  }

  onStart() {
    if (!this.startButtonflag) return;
    this.startButtonflag = false;

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "	quizStartClick",
      uniqID: Global.U_ID,
    });

    this.quizGameTry++;
    this.quizTitleIndex = 100;
    this.quizTitleInt = setInterval(() => {
      this.quizTitleIndex -= 100 / 34;

      if (this.quizTitleIndex <= 1) {
        clearInterval(this.quizTitleInt);

        document
          .querySelector("#quizhomeScr .contents .logo")
          .classList.remove(`active`);
        document
          .querySelector("#quizhomeScr .contents .desc")
          .classList.remove(`active`);
        document.querySelector("#quizstartBtn").classList.remove(`active`);

        document.querySelector(".bottomBg").classList.add(`active`);

        document.querySelector("#quizQuestionScr").style.display = "flex";
        setTimeout(() => {
          document.querySelector("#quizhomeScr").style.display = "none";
          this.startQuiz();
          document.querySelector(".quizScrLogo").classList.add("active");
        }, 300);
      }

      this.quiztitleContainer.style.backgroundPosition = `0% ${this.quizTitleIndex}%`;
    }, 30);
  }

  startQuiz() {
    this.score = 0;
    this.currentIndex = 0;
    this.question_displayed = {};
    this.ques_answered = {};

    // Get scenario key (conflict / cyclone / remote)
    // const key = Global.scenario;
    const key = "conflict";

    // Get that scenario's question list
    let list = quiz_Questions[key];

    // Shuffle
    let shuffled = this.shuffleArray([...list]);

    this.selectedQuestions = shuffled.slice(0, Math.min(5, shuffled.length));

    // Pick first 5
    // this.selectedQuestions = list.slice(0, 5);

    this.showQuestion();
    this.assignDetails();
  }

  shuffleArray(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  showQuestion() {
    const q = this.selectedQuestions[this.currentIndex];

    gsap.to(".questionContainer,.questionCountText, .optionBtns", {
      opacity: 1,
      x: 0,
      duration: 0.4,
      // stagger: 0.25,
      onComplete: () => {
        if (this.timeStartOnce) {
          this.timeStartOnce = false;
          this.startTimer();
        }
      },
    });

    // Update counter text
    this.counterText.innerHTML = `<span> सवाल </span> ${this.currentIndex + 1}/5`;

    // Reset button color
    this.factBtn.style.backgroundColor = "#4b4b4b";
    this.fakeBtn.style.backgroundColor = "#4b4b4b";

    // GSAP transition (fade-out old → fade-in new)
    gsap.to(".questionContainer", {
      opacity: 0,
      x: -40,
      duration: 0.3,
      onComplete: () => {
        this.qImg.style.display = "none";
        this.qVideo.style.display = "none";
        this.qVideo.pause();
        this.qVideo.src = "";
        this.qImg.src = "";

        this.qText.style.fontSize = "3.8vw";
        // Video?
        if (q.video) {
          this.qVideo.pause();
          this.qVideo.currentTime = 0;

          this.qVideo.src = q.video;

          this.qVideo.muted = true;
          this.qVideo.setAttribute("playsinline", "");
          this.qVideo.setAttribute("webkit-playsinline", "");

          this.qVideo.load();

          const playPromise = this.qVideo.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }

          this.qVideo.style.display = "block";
          this.qImg.style.display = "none";
        }

        // Image?
        else if (q.img) {
          this.qImg.src = q.img;
          this.qImg.style.display = "block";

          this.qVideo.pause();
          this.qVideo.style.display = "none";
        } else {
          if (q.id == 1) {
            this.qText.style.fontSize = "5vw";
          } else {
            this.qText.style.fontSize = "8vw";
          }
        }

        this.qText.innerHTML = q.text;
        this.question_displayed[`question_${this.currentIndex + 1}`] = q.text;

        // console.log(this.question_displayed);

        gsap.fromTo(
          ".questionContainer",
          { opacity: 0, x: 40 },
          {
            opacity: 1,
            x: 0,
            duration: 0.3,
            onComplete: () => {
              this.optionButtonFlag = true;
            },
          },
        );
      },
    });
  }

  checkAnswer(userAnswer) {
    if (!this.optionButtonFlag || this.timeUp) return;
    this.optionButtonFlag = false;

    this.ques_answered[`answer${this.currentIndex + 1}`] = userAnswer;
    // console.log(this.ques_answered);

    const correct = this.selectedQuestions[this.currentIndex].answer;

    const userBtn = userAnswer === "FACT" ? this.factBtn : this.fakeBtn;

    if (userAnswer === correct) {
      this.score++;
      userBtn.style.backgroundColor = "green";
    } else {
      userBtn.style.backgroundColor = "red";
      // show correct answer
      // if (correct === "FACT") this.factBtn.style.backgroundColor = "green";
      // if (correct === "FAKE") this.fakeBtn.style.backgroundColor = "green";
    }
    setTimeout(() => {
      this.pauseTimer();
      document.querySelector(".blackTint").classList.add("active");

      document.querySelector(".detailContainer").classList.add("active");
      gsap.to(".detailContainer", {
        y: "-50%",
        duration: 0.4,
        ease: "power1.out",
        delay: 0,
        onComplete: () => {},
      });
    }, 1500);
  }

  closeDetailsPopUp() {
    gsap.to(".detailContainer", {
      y: "200%",
      duration: 0.4,
      ease: "power1.out",
      delay: 0,
      onComplete: () => {
        document.querySelector(".blackTint").classList.remove("active");

        this.startTimer();

        setTimeout(() => {
          this.currentIndex++;

          if (this.currentIndex < this.selectedQuestions.length) {
            this.showQuestion();
            this.assignDetails();
          } else {
            this.timeUp = true;
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            gsap.to(".questionContainer,.questionCountText, .optionBtns", {
              opacity: 0,
              x: -40,
              duration: 0.4,
              stagger: 0.25,
              onComplete: () => {
                this.showResult();
              },
            });
          }
        }, 400);
      },
    });
  }

  showResult() {
    var timeTaken = this.timeTaken_360 + (60 - this.time);
    timeTaken = String(timeTaken);
    this.total_time_Taken = timeTaken;

    var timeTaken_quiz = String(60 - this.time);

    Global.serverObj.send(
      Global.URL_UPLOAD,
      null,
      null,
      {
        uniqID: Global.U_ID,
        timeTaken: timeTaken,
      },
      "POST",
      null,
      false,
    );

    Global.serverObj.send(Global.URL_DATA_QUIZ, null, null, {
      saveType: "score",
      score: this.score,
      time: timeTaken_quiz,
      uniqID: Global.U_ID,
      question_01: this.question_displayed["question_1"],
      question_02: this.question_displayed["question_2"],
      question_03: this.question_displayed["question_3"],
      question_04: this.question_displayed["question_4"],
      question_05: this.question_displayed["question_5"],

      question_01_answer: this.ques_answered["answer1"],
      question_02_answer: this.ques_answered["answer2"],
      question_03_answer: this.ques_answered["answer3"],
      question_04_answer: this.ques_answered["answer4"],
      question_05_answer: this.ques_answered["answer5"],
    });

    this.line1 = document.querySelector(".quizResultPage .container2 .line1");
    this.line2 = document.querySelector(".quizResultPage .container2 .line2");

    this.line1Text = "";
    switch (this.score) {
      case 0:
        this.line1Text = `ओह नो! फिर से ट्राई करिए`;
        break;
      case 1:
        // this.line1Text = `बढ़िया कोशिश, अच्छा खेले आप`;
        this.line1Text = `बढ़िया कोशिश, अच्छा खेले आप`;
        break;
      case 2:
        this.line1Text = `अरे वाह, क्या बात है!`;
        break;
      case 3:
        this.line1Text = `बहुत बढ़िया!`;
        break;
      case 4:
        this.line1Text = `शाबाश!`;
        break;
      case 5:
        this.line1Text = `बढ़िया प्रदर्शन, क्या बात है!`;
        break;
      case 6:
        this.line1Text = `अद्भुत! आप छा गए. बधाई.`;
        break;
    }

    document.querySelector(".quizScrLogo").classList.remove("active");
    this.line1.innerHTML = this.line1Text;

    if (this.score == 0 || this.score == 1 || this.score == 2) {
      this.line2.innerHTML = `आपका स्कोर है 5 में से ${this.score}`;
    } else {
      this.line2.innerHTML = `आपका स्कोर है 5 में से ${this.score}<br>चीज़ों को परखने में आपकी कोशिश<br>तारीफ़ के काबिल है.`;
    }

    document.querySelector("#quizQuestionScr").style.display = "none";
    document.querySelector(".quizResultPage").style.display = "flex";

    this.quizTitleFrame = 0;
    this.quiztitleContainerFinalScr = document.querySelector(
      ".quizResultPage .container1 .quiztitle",
    );
    this.quizTitleInt1 = setInterval(() => {
      this.quizTitleFrame += 100 / 34;

      if (this.quizTitleFrame >= 99) {
        clearInterval(this.quizTitleInt1);

        document
          .querySelector(".quizResultPage .container1 .logo")
          .classList.add(`active`);
        this.line1.classList.add(`activeOpacityIn`);
        this.line2.classList.add(`activeOpacityIn`);
        document
          .querySelector(".quizResultPage .container2 .line3")
          .classList.add(`activeOpacityIn`);
        // document.querySelectorAll('.btn_container .buttons').forEach((btn, index) => {
        //   setTimeout(() => {
        //     btn.classList.add(`active`);
        //   }, index * 150);
        // });

        if (this.score == 5) {
          document
            .querySelector(".btn_container #quizShareBtn")
            .classList.add(`active`);
          document.querySelector(
            ".btn_container #quizTryAgainBtn",
          ).style.display = "none";
        } else if (this.score < 5) {
          document
            .querySelector(".btn_container #quizTryAgainBtn")
            .classList.add(`active`);
          document
            .querySelector(".btn_container #quizShareBtn")
            .classList.add(`active`);
        }
      }

      this.quiztitleContainerFinalScr.style.backgroundPosition = `0% ${this.quizTitleFrame}% `;
    }, 35);
  }

  startTimer() {
    if (this.timeUp) return;

    this.timeInterval = setInterval(() => {
      this.time--;
      document.querySelector("#timerText").innerHTML = `${this.time}`;
      if (this.time <= 0) {
        this.timeUp = true;
        clearInterval(this.timeInterval);
        this.timeInterval = null;
        gsap.to(".questionContainer,.questionCountText, .optionBtns", {
          opacity: 0,
          x: -40,
          duration: 0.4,
          stagger: 0.25,
          onComplete: () => {
            this.showResult();
          },
        });
      }
    }, 1000);
  }

  assignDetails() {
    // const w = this.selectedQuestions[0];
    const w = this.selectedQuestions[this.currentIndex];

    this.ansVideo.pause();
    this.ansVideo.src = "";
    this.ansImg.src = "";
    this.ansIFrame.src = "";
    // Optional: reset iframe completely
    this.ansIFrame.removeAttribute("src");

    // Video?
    if (w.ansVideo) {
      this.ansVideo.pause();
      this.ansVideo.currentTime = 0;

      this.detailsImage.style.display = "block";
      this.detailsText.style.height = "54%";

      this.ansVideo.src = w.ansVideo;

      this.ansVideo.muted = true;
      this.ansVideo.setAttribute("playsinline", "");
      this.ansVideo.setAttribute("webkit-playsinline", "");

      this.ansVideo.load();

      const playPromise = this.ansVideo.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }

      this.ansVideo.style.display = "block";

      this.ansImg.style.display = "none";
      this.ansIFrame.style.display = "none";
      // console.log("playing answer video");
    }

    // Image?
    else if (w.ansImg) {
      this.detailsImage.style.display = "block";
      // this.detailsText.style.height = "54%";
      this.ansImg.src = w.ansImg;

      this.ansVideo.pause();
      this.ansImg.style.display = "block";
      this.ansVideo.style.display = "none";
      this.ansIFrame.style.display = "none";
      // console.log("showing answer image");
    } else if (w.ansIFrame) {
      this.detailsImage.style.display = "block";
      // this.detailsText.style.height = "54%";
      this.ansVideo.style.display = "none";
      this.ansImg.style.display = "none";
      this.ansIFrame.style.display = "block";
      this.loadIframe(w.ansIFrame);
      // console.log("loading answer iframe");
    } else {
      this.detailsImage.style.display = "none";
      // this.detailsText.style.height = "100%";
      // console.log("no answer media");
    }
    this.detailsText.innerHTML = w.context;
  }

  loadIframe(videoId) {
    this.loader.style.display = "flex"; // show loader
    // this.ansIFrame.style.display = "none";   // hide iframe initially

    this.ansIFrame.src = videoId; // assign the link

    // When iframe finishes loading
    this.ansIFrame.onload = () => {
      this.loader.style.display = "none"; // hide loader
      // this.ansIFrame.style.display = "block"; // show iframe content
    };
  }

  pauseTimer() {
    clearInterval(this.timeInterval);
    this.timeInterval = null;
  }

  retryQuiz() {
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "quizTryAgainClick",
      uniqID: Global.U_ID,
    });

    this.timeUp = false;
    this.timeStartOnce = true;
    this.time = 60;
    document.querySelector("#timerText").innerHTML = `${this.time}`;

    this.quizTitleFrame = 100;
    this.quiztitleContainerFinalScr = document.querySelector(
      ".quizResultPage .container1 .quiztitle",
    );
    this.quizTitleInt1 = setInterval(() => {
      this.quizTitleFrame -= 100 / 34;

      if (this.quizTitleFrame <= 1) {
        clearInterval(this.quizTitleInt1);

        document
          .querySelector(".quizResultPage .container1 .logo")
          .classList.remove(`active`);
        this.line1.classList.remove(`activeOpacityIn`);
        this.line2.classList.remove(`activeOpacityIn`);
        document
          .querySelector(".quizResultPage .container2 .line3")
          .classList.remove(`activeOpacityIn`);
        document
          .querySelectorAll(".btn_container .buttons")
          .forEach((btn, index) => {
            setTimeout(() => {
              btn.classList.remove(`active`);
            }, index * 150);
          });
        document.querySelector("#quizQuestionScr").style.display = "flex";

        setTimeout(() => {
          document.querySelector(".quizResultPage").style.display = "none";
          this.startQuiz();
          document.querySelector(".quizScrLogo").classList.add("active");
        }, 100);
      }

      this.quiztitleContainerFinalScr.style.backgroundPosition = `0% ${this.quizTitleFrame}% `;
    }, 35);
  }

  async shareThumbnail() {
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "	quizShareClick",
      uniqID: Global.U_ID,
    });

    try {
      // const imgURL = `https://newsfeedsmartapp.com/BBCFactVsFake/api/uploads/${Global.U_ID}/ThumbnailTemp.jpg`;
      const imgURL = `https://newsfeedsmartapp.com/BBCFactVsFake/api/get-image.php?uid=${Global.U_ID}`;

      // Fetch image and convert to blob
      const response = await fetch(imgURL);
      const blob = await response.blob();
      const file = new File([blob], "thumbnail.jpg", { type: blob.type });

      // Share
      await navigator.share({
        files: [file],
        title: "Check this out!",
        // text: "Sharing the thumbnail image"
        text: `काफी फ़ास्ट! मैंने सिर्फ ${this.total_time_Taken} सेकंड में BBC News Ground Zero Challenge पूरा किया। क्या आप मेरा रिकॉर्ड तोड़ सकते हैं? Try here - https://bbcnewsgroundzero.com/`,
      });
    } catch (err) {
      // console.log("Sharing failed:", err);
    }
  }
}
